import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Plan } from "@/types";
import { toast } from "react-toastify";
import { createPlans, deletePlans, fetchPlans, updatePlans } from "./thunks";

interface PaginatedPlans {
  data: Plan[];
  total?: number;
  currentPage?: number;
  perPage?: number;
}

interface PlansState {
  planSubscription: PaginatedPlans;
  loading: boolean;
  error: string | null;
}

const initialState: PlansState = {
  planSubscription: { data: [] },
  loading: false,
  error: null,
};

const PlanSubscriptionSlice = createSlice({
  name: "planSubscription",
  initialState,
  reducers: {
    clearPlans: (state) => {
      state.planSubscription = { data: [] };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlans.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const payload = action.payload;

        if (Array.isArray(payload.data)) {
          // Dados não paginados
          state.planSubscription = { data: payload.data };
        } else {
          // Dados paginados
          state.planSubscription = {
            data: payload.data.data,
            total: payload.data.total,
            currentPage: payload.data.current_page,
            perPage: payload.data.per_page,
          };
        }
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      })
      // Create
      .addCase(createPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPlans.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.planSubscription.data.push(action.payload.data);
        toast.success("Plano cadastrado com sucesso!");
      })
      .addCase(createPlans.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error("Não foi possível cadastrar o plano, tente novamente!");
      })

      // Update
      .addCase(updatePlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePlans.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const index = state.planSubscription.data.findIndex(
          (s) => s.id == action.payload.data.id,
        );
        if (index !== -1) {
          state.planSubscription.data[index] = action.payload.data;
        }
        toast.success("Plano atualizado com sucesso!");
      })
      .addCase(updatePlans.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        console.log("error", state.error);
        toast.error("Error");
      })

      // Delete
      .addCase(deletePlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePlans.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.planSubscription.data = state.planSubscription.data.filter(
          (s) => String(s.id) != action.payload.data.id,
        );
        toast.success("Plano excluído com sucesso!");
      })
      .addCase(deletePlans.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      });
  },
});

export default PlanSubscriptionSlice.reducer;
